// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"c0a15b87","284":"0bdfc52d","787":"a54cc342"}[chunkId] + ".chunk.js";
};